import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Calendar, Whisper, Popover } from 'rsuite';
import styled from 'styled-components';
import useSWR from 'swr';
import axios from 'axios';

import 'rsuite/Calendar/styles/index.css';
import 'rsuite/Popover/styles/index.css';


let dataCaches = {};

const EmployeeCalendar = () => {

    const { data: demartmentRes } = useSWR(`/api/employee/departments`, axios);
    const [ nowDate, setNowDate ] = useState(new Date());
    const [ selectedDepartment, setSelectedDepartment ] = useState();
    const departments = useMemo(() => demartmentRes?.data || [], [demartmentRes]);
    const [ loading, setLoading ] = useState(false);
    const [ nowDayoffs, setNowDayoffs ] = useState([]);

    const nowMonth = useMemo(() => `${nowDate.getFullYear()}-${nowDate.getMonth() + 1}`, [nowDate]);

    useEffect(() => {
        setLoading(true);
        fetchDayoffs(nowDate, selectedDepartment).then(data => {
            setNowDayoffs(data);
            setLoading(false);
        });
    }, [nowDate, selectedDepartment]);

    function getSearchParamString(date, departmentId) {
        const searchParams = new URLSearchParams();
        searchParams.append('year', date.getFullYear());
        searchParams.append('month', date.getMonth() + 1);
        if (departmentId) {
            searchParams.append('department', departmentId);
        }

        return searchParams.toString();
    }

    async function fetchDayoffs(date, departmentId) {
        const searchParamsString = getSearchParamString(date, departmentId);

        let data = undefined;

        if (dataCaches[searchParamsString]) {
            data = dataCaches[searchParamsString];
        }
        else {
            const res = await axios.get(`/api/employee/user-dayoffs?${searchParamsString}`);
            data = res?.data || [];
            dataCaches[searchParamsString] = data;
        }

        return data;
    }

    function handleDepartmentChange(e) {
        setSelectedDepartment(e.target.value || undefined);
    }

    function formatDate(date) {
        let year = date.getFullYear();
        let month = (date.getMonth() + 1).toString().padStart(2, '0');
        let day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
      }

    const renderCell = useCallback(date => {
        // date to string format 2024-01-01
        const dateStr = formatDate(date);

        const list = nowDayoffs.filter(d => d.date === dateStr);
        const displayList = list.filter((item, index) => index < 2);

        if (list.length) {
            const moreCount = list.length - displayList.length;
            const moreItem = (
                <li>
                    <Whisper
                        placement="top"
                        trigger="click"
                        speaker={
                            <Popover>
                                {list.map((item, index) => (
                                    <p key={index}>
                                        { item.user }
                                    </p>
                                ))}
                            </Popover>
                        }
                    >
                        <a>{moreCount} more</a>
                    </Whisper>
                </li>
            );

            return (
                <ul className="calendar-todo-list">
                    {displayList.map((item, index) => (
                        <li key={index}>
                            {item.user}
                        </li>
                    ))}
                    {moreCount ? moreItem : null}
                </ul>
            );
        }

        return null;
    }, [nowDayoffs]);

    return (
        <CalendarWrapper>
            <div className='employee-calendar-departments'>
                <div className="title">休假行事曆</div>
                <label>部門</label>
                <select onChange={handleDepartmentChange}>
                    <option value="">（全部）</option>
                    {departments.map((department, index) => (
                        <option key={index} value={department.id}>{department.name}</option>
                    ))}
                </select>
            </div>
            <StyledCalendar bordered renderCell={renderCell} weekStart={1} value={nowDate} onChange={setNowDate} />
        </CalendarWrapper>
    );
}

const CalendarWrapper = styled.div`
    background-color: white;
    border-radius: 8px;
`

const StyledCalendar = styled(Calendar)`
    
`

export default EmployeeCalendar
